import { render, staticRenderFns } from "./29_main.vue?vue&type=template&id=6232db35"
import script from "./29_main.vue?vue&type=script&lang=js"
export * from "./29_main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports